<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>
    <div id="main-panel" class="main main-raised">
      <div id="my-forum" class="cd-section section section-basic" style="padding-top:45px">
        <div class="md-layout">
          <div class="md-layout-item md-size-65 md-medium-size-75 md-small-size-95 mx-auto">
            <h2 class="black text-primary text-center">{{$t('My Forum')}}</h2>

            <user-profile
              class="md-layout-item md-size-100"
              style="margin:20px 0px"
              v-if="isLoggedIn"
            />
            <my-agenda
              class="md-layout-item md-size-100"
              style="margin:20px 0px"
              v-if="isLoggedIn && hasAgendaAccess && agendaSettings.show"
              showFooter="true"
              showHeader="true"
            />
            <notifications
              class="md-layout-item md-size-100"
              style="margin:20px 0px"
              v-if="isLoggedIn"
            />
            <information class="md-layout-item md-size-100" style="margin:20px 0px" />
          </div>
        </div>
      </div>

      <div id="partners-list" class="cd-section section section-basic" style="padding-top:70px">
        <div class="md-layout">
          <div class="md-layout-item md-size-65 md-medium-size-75 md-small-size-95 mx-auto">
            <h2 class="black text-primary text-center" style="margin-top:0px">{{$t('Partners')}}</h2>
            <partners></partners>
          </div>
        </div>
      </div>

      <div
        id="map-container"
        class="cd-section section section-basic"
        style="padding-top:70px;padding-bottom:70px"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-size-65 md-medium-size-75 md-small-size-95 mx-auto"
            style="margin-bottom:40px"
          >
            <h2 class="black text-primary text-center">{{$t('Map')}}</h2>
          </div>
          <div class="md-layout-item md-size-90 mx-auto">
            <Map />
          </div>
        </div>
      </div>
    </div>

    <nav id="cd-vertical-nav" class="vertical-nav-active">
      <ul>
        <li>
          <a data-number="1" @click="scrollToElement('my-forum')">
            <span class="cd-dot" />
            <span class="cd-label">{{$t('My Forum')}}</span>
          </a>
        </li>

        <li>
          <a data-number="2" @click="scrollToElement('partners-list')">
            <span class="cd-dot" />
            <span class="cd-label">{{$t('Partners')}}</span>
          </a>
        </li>
        <li>
          <a data-number="3" @click="scrollToElement('map-container')">
            <span class="cd-dot" />
            <span class="cd-label">{{$t('Map')}}</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import Information from "./components/Landing/Information";
import Partners from "./components/Landing/Partners";
import UserProfile from "./components/Landing/UserProfile";
import Notifications from "./components/Landing/LatestNotifications";
import MyAgenda from "./components/Landing/MyAgenda";
import Map from "./components/Landing/Map";
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import PageHeader from "./layout/PageHeader";

export default {
  components: {
    PageHeader,
    Information,
    Partners,
    Map,
    UserProfile,
    Notifications,
    MyAgenda
  },
  mixins: [Mixins.VerticalNav, Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      isLoggedIn: "user/isLoggedIn",
      hasAgendaAccess: "user/hasAgendaAccess",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      hasChatAccess: "user/hasChatAccess",
      agendaSettings: "user/agendaSettings",
      attendeesSettings: "user/attendeesSettings"
    })
  },
  data() {
    return {
      image: require("@/assets/img/conference/landing-bg.jpg")
    };
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>

<style lang="scss" scoped>
#my-forum,
#partners-list,
#map-container {
  padding: 10px;
}
</style>

<style lang="scss">
div.landing-page.card {
  padding: 16px;
  position: relative;
  border-radius: 0px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: color, background-color;
  will-change: color, background-color;

  .card-header {
    margin: 0px;
    font-size: 26px;
  }
}
</style>

<style lang="scss" scoped>
h1.info-title {
  font-size: 4rem;
}
.info-title {
  color: white !important;
}

.page-header .container {
  max-width: 80% !important;
}
</style>
